module.exports = __webpack_public_path__ + "static/media/Payment_Crypto.57e1cf12.png";